import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Heart } from 'lucide-react';
export const Transformation = () => {
  return <section className="py-16 bg-gradient-to-b from-pink-light/50 to-base relative overflow-hidden" data-id="element-291">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-fuchsia opacity-30 pointer-events-none" data-id="element-292" />

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-293">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-294">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-3 leading-tight" data-id="element-295">
            De empleada cansada a{' '}
            <span className="text-fuchsia italic" data-id="element-296">
              dueña de tu propio negocio beauty
            </span>
          </h2>
          <p className="text-text-muted text-sm md:text-base" data-id="element-297">
            Tu pasaporte hacia la independencia económica y la libertad real.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-298">
          {[{
          icon: TrendingUp,
          stat: '+$2.400.000',
          label: 'ARS/mes extra',
          text: 'Reportado por alumnas en sus primeros 3 meses.'
        }, {
          icon: Users,
          stat: '+45 clientas',
          label: 'Nuevas',
          text: 'En 90 días con nuestras estrategias en redes.'
        }, {
          icon: Heart,
          stat: 'Libertad',
          label: 'Real',
          text: 'Tú decides horarios y cuánto cobras por tu arte.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white/90 backdrop-blur-sm p-5 rounded-2xl text-center shadow-sm border border-white" data-id="element-299">
              <div className="w-11 h-11 mx-auto bg-gradient-fuchsia rounded-xl flex items-center justify-center text-white mb-4 shadow-glow" data-id="element-300">
                <item.icon className="w-5 h-5" data-id="element-301" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-text-main mb-1 leading-tight" data-id="element-302">
                {item.stat}
              </h3>
              <p className="text-xs text-fuchsia font-bold uppercase tracking-wider mb-2" data-id="element-303">
                {item.label}
              </p>
              <p className="text-text-muted text-xs leading-snug" data-id="element-304">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};